import { createGlobalStyle } from "styled-components";

// =====================================================================
// GlobalStyles — PharuERP
// =====================================================================
// Refatorado em 2026-XX-XX (Sprint 1 Foundation):
//   - Removido :root { --font-display, --font-body }: agora vem de
//     src/styles/canonical/tokens.css (definido como "Sora").
//   - Removido reset *{}, font-family body{}, scrollbar custom:
//     src/styles/canonical/system.css já cobre.
//   - Preservado: --app-header-height (legacy, aponta pra --topbar-height
//     canônica), a11y (:focus-visible, .visually-hidden, prefers-reduced-motion),
//     export-mode (data-export-mode com regras pra html2canvas).
// =====================================================================

const GlobalStyles = createGlobalStyle`
  :root {
    /* Legacy alias — código antigo usa --app-header-height.
       Aponta pra --topbar-height definido em canonical/tokens.css. */
    --app-header-height: var(--topbar-height);
  }

  body {
    /* Scroll-padding pra elementos focados não ficarem cobertos pelo
       Topbar sticky (canonical: 56px via --topbar-height). */
    scroll-padding-top: var(--app-header-height);
  }

  #root {
    min-height: 100vh;
  }

  /* Acessibilidade: foco visível sistêmico em todos os interativos.
     :focus-visible só dispara em navegação por teclado (não em mouse). */
  :focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
    border-radius: 4px;
  }

  /* WCAG 2.3.3 — usuários que preferem reduced motion. */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  /* Esconde visualmente mas mantém para screen readers. */
  .visually-hidden {
    position: absolute !important;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  /* ==================================================================
     EXPORT MODE — html2canvas snapshot
     ==================================================================
     body[data-export-mode="true"] neutraliza animações + sticky/fixed
     pra captura visual ficar limpa. Aplicado seletivamente em vez de "*"
     pra não quebrar modais semi-transparentes / transforms intencionais.
     ================================================================== */
  body[data-export-mode="true"] [data-export-expand],
  body[data-export-mode="true"] [data-export-expand] *,
  body[data-export-mode="true"] [data-pdf],
  body[data-export-mode="true"] [data-pdf] * {
    max-height: none !important;
    max-width: none !important;
    overflow: visible !important;
  }

  /* Zera padding-left da MainArea (que reflete largura da sidebar) e
     max-width do PageContainer durante captura — evita faixa branca
     à esquerda ou margem direita exagerada na imagem. */
  body[data-export-mode="true"] [data-app-shell] {
    padding-left: 0 !important;
    padding-top: 0 !important;
    transition: none !important;
  }
  body[data-export-mode="true"] [data-page-container] {
    max-width: none !important;
    margin: 0 !important;
    padding: 24px !important;
  }

  /* Terceiros 5b: durante exportação, AmbientesList vai pra grid 2-col. */
  body[data-export-mode="true"] [data-export-ambientes-grid] {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 12px !important;
  }

  /* Neutraliza framer-motion mid-animation (opacity:0 inicial, slide, fade). */
  body[data-export-mode="true"] *,
  body[data-export-mode="true"] *::before,
  body[data-export-mode="true"] *::after {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
    animation: none !important;
  }
  body[data-export-mode="true"] [data-export-no-print] {
    display: none !important;
  }

  /* O html2canvas nao desenha box-shadow inset como faixa: ele recorta a
     border-box e usa como mascara o retangulo do canvas MENOS a celula, e o
     que sai e uma AREA cheia. Era a "caixa dentro do card" nos KPIs e o bloco
     de cor por cima do nome do cliente. Como toda sombra aqui e decorativa
     (highlight de vidro de 5%, regua de 1px), some inteira da captura — quem
     precisa de linha visivel a redesenha com border ou pseudo-elemento
     (ver Th e Td do PainelTabela). */
  body[data-export-mode="true"] [data-pdf],
  body[data-export-mode="true"] [data-pdf] *,
  body[data-export-mode="true"] [data-export-expand],
  body[data-export-mode="true"] [data-export-expand] * {
    box-shadow: none !important;
  }

  /* sticky/fixed viram static no modo exportação (evita duplicação de
     header e elementos flutuantes na captura). */
  body[data-export-mode="true"] thead th,
  body[data-export-mode="true"] th,
  body[data-export-mode="true"] [style*="position: sticky"],
  body[data-export-mode="true"] [style*="position:sticky"],
  body[data-export-mode="true"] [style*="position: fixed"],
  body[data-export-mode="true"] [style*="position:fixed"] {
    position: static !important;
    top: auto !important;
    box-shadow: none !important;
  }
`;

export default GlobalStyles;
